


































































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import { Page } from '@/interfaces/api/Page';
import { Model } from '@/interfaces/models/Model';

@Component
export default class VTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: any;
  @Prop({ type: Array, required: true }) public headers!: ColumnHeader[];
  @Prop({ type: String, default: '' }) public search!: string;
  @Prop({ type: Boolean, default: true }) public pagination!: boolean;
  @Prop({ type: Boolean, default: false }) public selectable!: boolean;
  @Prop({ type: Number, required: false }) public total!: number;
  @Prop({ type: [Function, Boolean], default: true }) public editable!: boolean | ((item: any) => boolean);
  @Prop({ type: [Function, Boolean], default: false }) public deleteable!: boolean | ((item: any) => boolean);
  @Prop({ type: Boolean, default: false }) public customActions!: boolean;
  @Prop({ type: Boolean, default: false }) public loading!: boolean;
  @Prop({ type: Boolean, default: false }) public expandable!: boolean;

  public page: number = 1;

  protected selected: any[] = [];

  protected selectedAll: boolean = false;

  protected editDialog = {
    isVisible: false,
    value: null,
    name: '',
    original: null,
  };

  @Emit('page')
  @Watch('page')
  public onPageChange(): Page {
    if (this.$route.query.page && parseInt(this.$route.query.page as string, 10) !== this.page) {
      // @ts-ignore
      this.$router.push({ query: { page: this.page } });
    }

    return { page: this.page };
  }

  public mounted(): void {
    if (this.$route.query.page) {
      this.page = parseInt(this.$route.query.page as string, 10);
      this.$emit('page', { page: this.page });
    } else {
      // @ts-ignore
      this.$router.push({ query: { page: this.page } });
    }
  }

  public isEditable(item: any) {
    if (typeof this.editable === 'function') {
      return this.editable(item);
    }

    return this.editable;
  }

  public mayDelete(item: any) {
    this.$confirm().then((res: boolean) => {
      if (res) {
        this.$emit('delete', item);
      }
    });
  }

  public isDeleteable(item: any) {
    if (typeof this.deleteable === 'function') {
      return this.deleteable(item);
    }

    return this.deleteable;
  }

  public isSelected(item: any) {
    return this.selected.indexOf(item) > -1;
  }

  public handleCellClick(header: ColumnHeader, item: any) {
    if (!header.editable || !this.editable) return;
    this.editDialog.isVisible = true;
    this.editDialog.name = header.value;
    this.editDialog.value = item[header.value].$numberDecimal ? item[header.value].$numberDecimal : item[header.value];
    this.editDialog.original = { ...item };
  }

  public saveCellValue() {
    this.$emit('edited', {
      original: this.editDialog.original,
      field: this.editDialog.name,
      value: this.editDialog.value,
    });
    this.stopEditing();
  }

  public stopEditing() {
    this.editDialog.isVisible = false;
    this.editDialog.value = null;
    this.editDialog.original = null;
    this.editDialog.name = '';
  }

  get actions() {
    return this.editable || this.deleteable || this.customActions;
  }

  get pageCount() {
    if (this.pagination) {
      return Math.ceil(this.total / 10);
    }

    return 0;
  }

  public showQr(url: string) {
    window.open(url, '_blank');
  }

  public toggleSelect(item: any) {
    if (this.isSelected(item)) {
      const index: number = this.selected.indexOf(item);
      this.selected.splice(index, 1);
    } else {
      this.selected.push(item);
    }
  }

  public toggleAll() {
    if (this.selectedAll) {
      this.selected.push(...this.items);
    } else {
      for (const item of this.items) {
        const index: number = this.selected.indexOf(item);
        if (index > -1) {
          this.selected.splice(index, 1);
        }
      }
    }
  }

  @Watch('selectedAll')
  public onSelectAllToggle() {
    this.toggleAll();
  }
}
